var _path, _path2, _g, _circle, _g2, _g3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 937,
    height: 730,
    viewBox: "0 0 937 730",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M783.783 420.08L886.03 328.896C905.5 316 941 352 923.303 370.691L821.055 461.874L783.783 420.08Z",
    fill: "#FFF3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M802.5 402.085L766 434.585L802.5 477.085L823 459.085C823 459.085 828 454.585 843.5 440.585C859 426.585 827.5 382.085 802.5 402.085Z",
    fill: "#FFE299"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1695_276)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 683.5,
    cy: 541.5,
    r: 180.5,
    fill: "#FFF3D6"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 684,
    cy: 541,
    r: 158,
    fill: "#99582A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1695_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.5 573C656 381 502.426 404.007 464 410C355 427 267.5 393 254.5 336.5C244.1 291.3 186.833 239.333 134 227.5C77.1999 227.5 92.4999 153 92.4999 90.5",
    stroke: "#E9D1C3",
    strokeOpacity: 0.5,
    strokeWidth: 40,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1695_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M726.5 576C767 527.5 861 435 778.5 392C739.3 371.569 656 314 726.5 241",
    stroke: "#E9D1C3",
    strokeOpacity: 0.5,
    strokeWidth: 20,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.677 656.19C754.565 658.036 744.145 659 733.5 659C638.231 659 561 581.769 561 486.5C561 481.453 561.217 476.456 561.641 471.518C549.783 492.123 543 516.02 543 541.5C543 619.096 605.904 682 683.5 682C713.742 682 741.752 672.445 764.677 656.19Z",
    fill: "#70411F",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1695_276",
    x: 499,
    y: 361,
    width: 369,
    height: 369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1695_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1695_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1695_276",
    x: 0.623779,
    y: 0.5,
    width: 767.878,
    height: 662.502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_1695_276"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1695_276",
    x: 629.108,
    y: 171,
    width: 252.247,
    height: 475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_1695_276"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.e748b0c3298053e467540510716284c7.svg";
export { ForwardRef as ReactComponent };